<mat-card appearance="outlined">
  <mat-card-content>
    <h2>{{ 'menu.label.unfinished_antrag' | translate }}</h2>
    <p>{{ 'new_antrag.text.unfinished_antrag_gathering' | translate }}</p>
    @if (!showRetry) {
      <section class="progress-section">
        <mat-spinner />
      </section>
    } @else {
      @if (errorMessage()) {
        <ebeihilfe-note type="danger" [messageText]="errorMessage() | translate" />
      }

      <button (click)="populateFirstUnfinishedAntrag()" color="primary" mat-flat-button>
        {{ 'general.label.reload.try_again' | translate }}
      </button>
    }
  </mat-card-content>
</mat-card>
